import React from "react";

interface LinkifiedTextProps {
  text: string;
}

const URL_REGEX = /((https?:\/\/|www\.)[^\s]+)/gi;

// Renders plain text with http(s):// and www. URLs turned into links. A
// trailing punctuation mark is kept out of the link so "see foo.com." works.
const LinkifiedText: React.FC<LinkifiedTextProps> = ({ text }) => {
  if (!text) return null;
  const nodes: React.ReactNode[] = [];
  const urlRegex = new RegExp(URL_REGEX);
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = urlRegex.exec(text)) !== null) {
    const start = match.index;
    const matchedUrl = match[0];
    const end = start + matchedUrl.length;
    const before = text.slice(lastIndex, start);
    if (before) nodes.push(before);
    let url = matchedUrl;
    let trailing = "";
    const trailingMatch = url.match(/[.,!?)]$/);
    if (trailingMatch) {
      trailing = trailingMatch[0];
      url = url.slice(0, -1);
    }
    const href = url.startsWith("http") ? url : `http://${url}`;
    nodes.push(
      <a
        key={`link-${start}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-biafit-primary underline hover:text-biafit-secondary"
      >
        {url}
      </a>
    );
    if (trailing) nodes.push(trailing);
    lastIndex = end;
  }
  const remaining = text.slice(lastIndex);
  if (remaining) nodes.push(remaining);
  return <>{nodes}</>;
};

export default LinkifiedText;
